import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistSectionReorderModel } from 'shared/domain/checklistSection/types/model';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistSectionHttpReorderRequestModel } from '../httpQueue/checklistSection/types';

export class ChecklistSectionReorderer {
  constructor(
    private addRequest: (
      request: ChecklistSectionHttpReorderRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    reorderModel: ChecklistSectionReorderModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('ReorderChecklistSectionUseCase', reorderModel);

    const url = `/project/${reorderModel.projectId}/inspectionTemplate/${reorderModel.inspectionTemplateId}/section/${reorderModel._id}/reorder`;

    const request: ChecklistSectionHttpReorderRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        beforeId: reorderModel.beforeId,
        afterId: reorderModel.afterId,
        parentSectionId: reorderModel.parentSectionId,
        projectId: reorderModel.projectId,
        inspectionTemplateId: reorderModel.inspectionTemplateId,
        sectionId: reorderModel._id,
        uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistSection,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistSectionReorderer = new ChecklistSectionReorderer(
  addRequest
);
